var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"home-container"},[_c('tHeader'),_c('div',{staticClass:"home-container-wrapper"},[_c('div',{class:['wrapper-left', _vm.app.menuStatus ? '' : 'small-wrapper-left']},[_c('tMenu')],1),_c('div',{staticClass:"wrapper-right"},[_c('tNav'),_c('router-view')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }